import styled from "styled-components";
import { FaExclamationTriangle } from "react-icons/fa";
import { createStyledIcon } from "utils/iconUtils";

const ExclamationTriangleIcon = createStyledIcon(FaExclamationTriangle);

export const ErrorModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ErrorTitle = styled.h2`
  color: ${({ theme }) => theme.colors.error};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorIcon = styled(ExclamationTriangleIcon)`
  margin-right: 8px;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.error};
`;

export const ErrorMessageList = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

export const ErrorMessageItem = styled.p`
  margin: 8px 0;
  font-size: 16px;
  text-align: left;
  text-align: center;
  color: #000000;

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.error};
    margin-right: 8px;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
